import { Button } from '@components/Button';
import { usePrivyUserContext } from '@providers/PrivyUserProvider';

export const SignInButton = (props: { full?: boolean; color?: 'white' }) => {
  const { onClickedConnect, signIn, isSigningLoginMessage } = usePrivyUserContext();

  return (
    <Button
      full={props.full}
      onClick={() => {
        onClickedConnect();
        signIn();
      }}
      disabled={isSigningLoginMessage}
      loading={isSigningLoginMessage}
      color={props.color}
    >
      {isSigningLoginMessage ? <span>Check wallet...</span> : <span>Sign in</span>}
    </Button>
  );
};
